import React from 'react';
import PropTypes from 'prop-types';
import SharedHero from '../../../shared/SharedHero';
import { API_URL } from '../../../api/axios';

const Hero = ({ title, cover }) => {
  return (
    <SharedHero title={title}>
      <img
        src={`${API_URL}${cover}`}
        className="absolute top-0 left-0 h-full w-full object-cover -z-10"
        alt="Cover image"
      />
      <div className="absolute top-0 left-0 h-full w-full object-cover -z-10 gradient-blue-62" />
    </SharedHero>
  );
};

Hero.propTypes = {
  title: PropTypes.string,
  cover: PropTypes.string,
};

export default Hero;
